import React, { useState } from "react";
import { createGlossary } from "../../../redux/ducks/glossary";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import LanguageSelect from "../LanguageSelect";
import TextInput from "../../dumb/TextInput";
import AreaInput from "../../dumb/AreaInput";
import useTargets from "../../../hook/useTargets";
import * as XLSX from "xlsx";
import Progress from "../../../helpers/progress";

const CreateGlossary = (props) => {
  const [show, hide, renderModal] = useModal();
  const [d_createGlossary, status, error, event] =
    useStatusThunk(createGlossary);
  const [isUploading, setIsUploading] = useState(false);
  const [name, setName] = useState();
  const [note, setNote] = useState();
  const [sourceLang, setSourceLang] = useState();
  const [file, setFile] = useState(null);
  const [sourceColumn, setSourceColumn] = useState(null);
  const [targets, renderButton, renderTargets, setTargets] = useTargets({
    disabled: isUploading, // Pass isUploading to disable the button
  });
  const [progress, setProgress] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [hideCloseButton, setHideCloseButton] = useState(false);

  let intId;

  const progressInterval = async () => {
    const progressValue = await Progress(); // Call the async function and wait for the result
    setProgress(progressValue.progress);
  };

  const startProgressInterval = () => {
    if (!intId) {
      intId = setInterval(progressInterval, 2000); // Start the interval
    }
  };

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);

    if (uploadedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryStr = event.target.result;

        try {
          // Read the file and calculate row count
          const workbook = XLSX.read(binaryStr, { type: "binary" });
          const sheetName = workbook.SheetNames[0]; // Get the first sheet
          const worksheet = workbook.Sheets[sheetName];
          const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Get rows as arrays
          setRowCount(data.length); // Set the row count
        } catch (error) {
          console.error("Error reading file:", error);
          setRowCount(0); // Reset on error
        }
      };
      reader.readAsArrayBuffer(uploadedFile); // Read the file as binary
    }
  };

  event.onPending = () => {
    setHideCloseButton(true);
    startProgressInterval();
    setIsUploading(true);
  };

  event.onFailure = () => {
    if (intId) {
      clearInterval(intId); // Clear the interval
      intId = null; // Reset the interval ID
    }
    setHideCloseButton(false);
    setIsUploading(false);
  };

  event.onSuccess = () => {
    if (intId) {
      clearInterval(intId); // Clear the interval
      intId = null; // Reset the interval ID
    }
    hide();
    setName(null);
    setNote(null);
    setSourceLang(null);
    setFile(null);
    setSourceColumn(null);
    setRowCount(0);
    setHideCloseButton(false);
    setTargets([]);
    setIsUploading(false);
  };

  return (
    <React.Fragment>
      <button
        className={"button button--glossary " + props.className}
        onClick={show}
      >
        Create Glossary
      </button>

      {renderModal(
        <React.Fragment>
          <div className="group">
            <div className="label">Glossary name</div>
            <TextInput disabled={isUploading} set={setName} v={name} />
          </div>

          <div className="group">
            <div className="label">Note</div>
            <AreaInput disabled={isUploading} set={setNote} v={note} />
          </div>

          <div className="double-inputs">
            <div className="group">
              <div className="label">Src</div>
              <LanguageSelect
                disabled={isUploading}
                onChange={(e) => setSourceLang(e.target.value)}
              />
            </div>

            <div className="group">
              <div className="label">Src col</div>
              <TextInput
                disabled={isUploading}
                set={setSourceColumn}
                v={sourceColumn}
              />
            </div>
          </div>

          {renderButton()}
          {renderTargets()}

          <div className="group">
            <div className="label">XLSX</div>
            <input
              type="file"
              accept=".xlsx"
              disabled={isUploading}
              onChange={handleFileChange}
            />
          </div>

          <div className="group">
            <DisplayError error={error} />
          </div>

          <LoadingButton
            disabled={!name || !sourceColumn || !sourceLang || !file}
            loading={status == "pending"}
            className="button--primary"
            progress={progress}
            onClick={(e) => {
              d_createGlossary({
                name,
                note,
                targets,
                sourceLang,
                file,
                sourceColumn,
                rowCount,
              });
            }}
          >
            Create Glossary
          </LoadingButton>
        </React.Fragment>,
        { hideCloseButton }
      )}
    </React.Fragment>
  );
};

export default CreateGlossary;
